import { useContext } from 'react'
import UserContext from 'shared/contexts/user'
import SideNav from 'shared/components/form/settings/side-nav'
import UploadClipsCTAComponent from 'shared/components/upload-clips-cta'
import withLocationState from 'shared/components/with-location-state'
import styled from 'styled-components'
import AnalyticsDisplay from '../user-dashboard-analytics/app'
import { fontCss } from '../user/components/container'
import DashboardUserContext from './context'
import DashboardBanner from './dashboard-banner'

const AccountManagementColumn = styled(SideNav)`
    ${fontCss};
    margin-right: 20px;
`
const DashboardColumn = styled.div`
    width: 770px;
`

const Container = styled.div`
    width: 1040px;
    display: flex;
    flex-wrap: wrap;
`

const UploadClipsCTA = styled(UploadClipsCTAComponent)`
    margin-bottom: 40px;
`

const DashboardPage = ({ dashboardUser, hasClips = false }) => {
    const { user } = useContext(UserContext)
    const showUploadClipsCTA = !hasClips && dashboardUser.channel_id === user.channelId // only show clips cta on logged in user's dashboard

    return (
        <DashboardUserContext.Provider value={{ user: dashboardUser }}>
            <div>
                <DashboardBanner />
                <Container>
                    <AccountManagementColumn user={dashboardUser} />
                    <DashboardColumn>
                        <AnalyticsDisplay>
                            {showUploadClipsCTA && <UploadClipsCTA gaCategory="dashboard" />}
                        </AnalyticsDisplay>
                    </DashboardColumn>
                </Container>
            </div>
        </DashboardUserContext.Provider>
    )
}

export default withLocationState(['dashboard_user', 'has_clips'])(DashboardPage)
